import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import DepartmentsMenu from "../DepartmentsMenu/DepartmentsMenu.jsx";
import SearchBar from "../SearchBar/SearchBar.jsx";
import ActionIcons from "../ActionIcons/ActionIcons.jsx";
import MobileMenu from "../MobileMenu/MobileMenu.jsx";
import { SecondaryNav } from "../SecondaryNav/SecondaryNav";
import { WebSiteSettingsService } from "../../services/webSiteSettigsServices.js";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const {
    data: settings,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["siteSettings"],
    queryFn: WebSiteSettingsService.getAllSettings,
    select: (data) => {
      if (Array.isArray(data)) {
        return (
          data.find((setting) => setting.is_active) ||
          data[0] ||
          getDefaultSettings()
        );
      }
      return data || getDefaultSettings();
    },
    staleTime: 5 * 60 * 1000,
    retry: 2, // Tentar 2 vezes antes de falhar
  });

  const getDefaultSettings = () => ({
    logo: "",
    site_title: "Loja Dominus",
    is_active: true,
  });

  const buscarProdutos = (termo) => {
    console.log("Buscando por:", termo);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isLoading) {
    return (
      <header className="">
        <nav className=" bg-gray-900 h-20">
          <div className="flex items-center justify-center h-full">
            <div className="animate-pulse bg-gray-700 w-24 h-8 rounded"></div>
          </div>
        </nav>
      </header>
    );
  }

  if (error) {
    console.error("Erro ao carregar configurações:", error);
    // Você pode tratar o erro de forma mais elegante se quiser
  }

  return (
    <header className="relative z-50">
      <nav
        className={`transition-all duration-300 bg-gray-900 ${
          isScrolled ? "" : ""
        }`}
        style={{ backgroundColor: settings?.secondary_color }}
      >
        <div className="max-w-full mx-auto px-4 md:px-6">
          <div className="flex items-center justify-around h-20">
            <div className="flex items-center mr-0 smb:mr-2 Iphones:mr-0">
              <Link
                to="/"
                className="flex items-center gap-3 scale-105 transition-all duration-200 transform hover:scale-110"
              >
                {settings?.logo ? (
                  <img
                    src={settings.logo}
                    alt="logo"
                    className="w-14 Iphones:w-16 Iphones2:w-16 md:w-24 lg:w-24 xl:w-16 h-auto mx-auto rounded-lg object-cover"
                  />
                ) : (
                  <img
                    src="/Logo-light.png"
                    alt="logo fallback"
                    className="w-14 Iphones:w-16 Iphones2:w-16 md:w-24 lg:w-24 xl:w-16 h-auto mx-auto rounded-lg object-cover"
                  />
                )}

                {!isMobile && (
                  <h1 className="hidden xl:flex font-serif uppercase font-bold text-white text-xl xl:text-lg 2xl:text-xl tracking-wide">
                    {settings?.site_title || "Dominus"}
                  </h1>
                )}
              </Link>
            </div>

            <div className="hidden md:flex items-center w-full max-w-3xl ml-6 md:ml-0 lg:ml-6 xl:-ml-0 gap-4">
              <DepartmentsMenu />
              <SearchBar onSearch={buscarProdutos} />
            </div>

            <div className="hidden md:flex items-center ml-0 md:ml-10 lg:0">
              <ActionIcons />
            </div>

            <div className="flex md:hidden w-fit m-2 smb:m-0 Iphones:m-2 Iphones2:m-2 items-center">
              <div className="md:hidden smb:mx-2 Iphones2:mx-4">
                <SearchBar onSearch={buscarProdutos} />
              </div>
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="text-white ml-2 p-2 rounded-md bg-transparent border-none cursor-pointer hover:bg-gray-800 focus:outline-none"
              >
                <svg
                  className="w-6 h-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  {mobileMenuOpen ? (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  ) : (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  )}
                </svg>
              </button>
            </div>
          </div>
        </div>
      </nav>

      <SecondaryNav />

      {mobileMenuOpen && <MobileMenu setMobileMenuOpen={setMobileMenuOpen} />}
    </header>
  );
};

export default Navbar;
